import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "\n      menu\n      menu-sub\n      menu-sub-dropdown\n      menu-column\n      menu-rounded\n      menu-gray-600\n      menu-state-bg-light-primary\n      fw-bold\n      py-4\n      fs-6\n      w-275px\n    ",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-5" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" My Profile ")
const _hoisted_4 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/pages/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}